import LaunchAppUI from '../index';
import getDomTree from './dom-tree';
import { trackEvent } from '../../utils/common';
let viewInstance = undefined;
const showPassphraseView = function (link) {
    viewInstance = new LaunchAppUI();
    const vDom = getDomTree(viewInstance, link);
    viewInstance.createUI(vDom, document.body);
    trackEvent('launch_app_passphrase_popup_expose');
};
export const asyncShowPassphraseView = function (link) {
    return new Promise((resolve, reject) => {
        viewInstance = new LaunchAppUI();
        const vDom = getDomTree(viewInstance, link, function (copyRes) {
            copyRes ? resolve() : reject();
        });
        viewInstance.createUI(vDom, document.body);
        trackEvent('launch_app_passphrase_popup_expose');
    });
};
export default showPassphraseView;
